module.exports = __webpack_public_path__ + "static/media/我的.23578448.svg";